import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Button, Loader } from "semantic-ui-react";
import { Result, message } from "antd";
import axios from "axios";
import queryString from "query-string";
import { handleResendLink } from "../../../helpers/resendVerification";

function VerifyAccount(props) {
  const [content, setContent] = useState({
    status: "success",
    message: "",
    actions: {
      success: {
        sub: "You will be automatically redirected to login page in 3 seconds or click on the button below",
        click: () => handleRedirect(),
      },
      info: {
        sub: "Your operation has been executed",
        click: async () => await handleResendFunction(),
      },
      error: {
        sub: "It seems like your token has expired, you will have to sign up again",
        click: async () => history.push("/auth"),
      },
    },
  });
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);

  const history = useHistory();
  const { search } = useLocation();
  const { token, uuid } = queryString.parse(search);

  useEffect(() => {
    const verification = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/users/verify?token=${token}&uuid=${uuid}`
        );
        if (response.status === 200) {
          setLoading(false);
          setContent({
            ...content,
            status: "success",
            message: "Success",
          });
          setTimeout(() => {
            history.push("/auth");
          }, 3000);
        }
      } catch (error) {
        setLoading(false);

        setContent({
          ...content,
          status: "error",
          message: "Error",
        });
        return error;
      }
    };
    verification();
  }, []);

  const handleRedirect = () => {
    return history.push("/auth");
  };

  const handleResendFunction = async () => {
    await handleResendLink(
      axios,
      token,
      setProcessing,
      setContent,
      content,
      message
    );
  };

  return (
    <>
      {loading ? (
        <Loader active />
      ) : (
        <Result
          status={content.status}
          title={content.message}
          subTitle={content.actions[content.status].sub}
          extra={[
            <Button
              positive={content.status === "success"}
              basic={content.status !== "success"}
              loading={processing}
              onClick={content.actions[content.status].click}
            >
              {content.status === "success" ? "Login" : "Sign up"}
            </Button>,
          ]}
        />
      )}
    </>
  );
}

export default VerifyAccount;
